import type { AppDispatch } from 'state';
import { resetStateOptions, resetStateValues } from '../index';

function resetFiltersView(dispatch: AppDispatch): void {
  dispatch(resetStateOptions());
  dispatch(resetStateValues());
}

export default resetFiltersView;
